import { default as bemCssModule } from 'bem-css-modules';
import React from 'react';
import { default as ThanksStyles } from './Thanks.module.css';
import { useTranslationByKey } from '../../../helpers/useTranslationByKeys';
const style = bemCssModule(ThanksStyles);
export const Thanks = (props) => {
    const t = useTranslationByKey();
    return (React.createElement("div", { className: style() },
        React.createElement("div", { className: `${style('icon')} ori-icon ori-icon--check-round` }),
        React.createElement("h2", { className: style('header') }, t('ThankYou')),
        React.createElement("p", { className: style('info') }, t('NotifyMesubscriptionSuccess', { 0: props.contactToUser }))));
};
